// extracted by mini-css-extract-plugin
module.exports = {"content":"ConfirmRenameModal_content__2XeOU","fileName":"ConfirmRenameModal_fileName__1zaWc"};